import axios from "axios";
console.log(process.env.VUE_APP_ENDPOINT);
var HOST = "";
if (process.env.VUE_APP_ENDPOINT === "local"){
    HOST = process.env.VUE_APP_LOCAL;
} else {
    HOST = process.env.VUE_APP_PROD;
}

const state = {
    visitorStatus: "new",
    visitorAuth: "",
    sessionID: "",
    loginForm: false,
    signinForm: false,
    resetForm: false,
    killSession: false
}

const getters = {
    getVisitorStatus:state =>{
        return state.visitorStatus;
    },
    getVisitorAuth:state => {
        return state.visitorStatus;
    },
    getHost(){
        return HOST;
    },
    getLoginForm:state =>{
        return state.loginForm;
    },
    getSigninForm:state =>{
        return state.signinForm;
    },
    getResetForm:state =>{
        return state.resetForm;
    },
    getSessionStatus:state =>{
        return state.killSession;
    }
}

const actions = {
    updateVisitorStatus:({ commit }, status) =>{
        console.log("/initial", status);
        if (status === "new"){
            console.log('inside "new"', HOST);
            axios.get(`${HOST}/initial`).then((data) => {
                console.log(data);
            });
            commit("setVisitorStatus", status);
        } else {
            console.log('inside: ', status, HOST);
            commit("setVisitorStatus", status);
        }
    },
    updateVisitorAuth:({ commit }, auth) =>{
        commit("setVisitorAuth", auth);
    },
    showLoginForm:({ commit }, status) =>{
        commit("setLoginForm", status);
    },
    showSigninForm:({ commit }, status) =>{
        console.log("SHOW SIGININ");
        commit("setSigninForm", status);
    },
    showResetForm:({ commit }, status) =>{
        commit("setResetForm", status);
    },
    sessionStatus:({ commit }, status) =>{
        console.log(status);
        axios.post(`${HOST}/session`, {body:status}).then((data) =>{
            console.log(data);
            commit('setSessionStatus', data);
        });
    }
}

const mutations = {
    setVisitorAuth:(state, auth) =>{
        state.visitorAuth = auth;
        return state.visitorAuth;
    },
    setVisitorStatus:(state, status) => {
        state.visitorStatus = status;
        return state.visitorStatus;
    },
    setLoginForm:(state, status) =>{
        state.loginForm = status;
        return state.loginForm;
    },
    setSigninForm:(state, status) =>{
        state.signinForm = status;
        return state.signinForm
    },
    setResetForm:(state, status) =>{
        state.resetForm = status;
        return state.resetForm;
    },
    setSessionStatus:(state, status) =>{
        state.killSession = status;
        return state.killSession;
    }

}

export default {
  state,
  getters,
  actions,
  mutations
};
